import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import axios from 'axios';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import config from '../../../config';

const AdmissionNews = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);

    // Responsive: detect mobile
    const isMobile = window.innerWidth <= 768;

    // Function to convert title to URL slug
    const createSlug = (title) => {
        if (!title) return '';
        return title
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd')
            .replace(/Đ/g, 'd')
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
    };

    // Function to create article URL
    const createArticleUrl = (post) => {
        const slug = createSlug(post.title);
        return `https://utt.edu.vn/tuyensinh/tuyen-sinh/dai-hoc-chinh-quy/${slug}-a${post.id}.html`;
    };

    // Fetch posts from API
    useEffect(() => {
        const fetchPosts = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${config.apiUrl}/api/v1/utt-posts`);

                if (response.data && response.data.data) {
                    setPosts(response.data.data);
                } else if (response.data && Array.isArray(response.data)) {
                    setPosts(response.data);
                }
            } catch (error) {
                console.error('Error fetching posts:', error);
                setPosts([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    // CSS for loading animation
    const pulseStyle = `
        @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
        }
    `; return (
        <>
            <style>{pulseStyle}</style>
            <section style={{ background: '#fff', padding: isMobile ? '24px 8px' : '60px 20px' }}>
                <div style={{
                    margin: '0 auto',
                    background: '#fff',
                    borderRadius: 16,
                    padding: isMobile ? 12 : 32
                }}>
                    <h2 style={{
                        fontSize: isMobile ? 22 : 32,
                        fontWeight: 600,
                        color: 'rgb(38, 34, 98)',
                        marginBottom: isMobile ? 18 : 32,
                        textAlign: 'center',
                        letterSpacing: 1
                    }}>Thông tin tuyển sinh</h2>

                    <Swiper
                        modules={[Navigation, Pagination]}
                        slidesPerView={isMobile ? 1 : 4}
                        spaceBetween={isMobile ? 8 : 30}
                        navigation={!isMobile}
                        pagination={{ clickable: true }}
                        style={{
                            paddingBottom: isMobile ? 24 : 40,
                            paddingLeft: isMobile ? 8 : 27,
                            paddingRight: isMobile ? 8 : 27,
                        }}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 8,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 16,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 24,
                            },
                            1024: {
                                slidesPerView: 4,
                                // spaceBetween: 30,
                            },
                        }}

                    >
                        {loading ? (
                            // Loading skeleton
                            [...Array(4)].map((_, idx) => (
                                <SwiperSlide key={`loading-${idx}`}>
                                    <div style={{
                                        background: '#f5f5f5',
                                        borderRadius: 12,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                        padding: isMobile ? 8 : 16,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        minHeight: isMobile ? 180 : 350,
                                        height: '100%',
                                        animation: 'pulse 1.5s ease-in-out infinite',
                                    }}>
                                        <div style={{
                                            width: '100%',
                                            height: isMobile ? 100 : 200,
                                            background: '#e0e0e0',
                                            borderRadius: 8,
                                            marginBottom: isMobile ? 8 : 16,
                                        }}></div>
                                        <div style={{
                                            width: '100%',
                                            height: isMobile ? 45 : 60,
                                            background: '#e0e0e0',
                                            borderRadius: 4,
                                            marginBottom: isMobile ? 6 : 12,
                                        }}></div>
                                        <div style={{
                                            width: '100%',
                                            height: isMobile ? 32 : 40,
                                            background: '#e0e0e0',
                                            borderRadius: 4,
                                        }}></div>
                                    </div>
                                </SwiperSlide>
                            ))
                        ) : posts.length > 0 ? (
                            posts.map((post, idx) => (
                                <SwiperSlide key={post.id || idx}>
                                    <div style={{
                                        background: '#fff',
                                        borderRadius: 12,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        padding: isMobile ? 8 : 16,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        minHeight: isMobile ? 180 : 350,
                                        height: '100%',
                                        cursor: 'pointer',
                                    }}>
                                        <a
                                            href={createArticleUrl(post)} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={`https://utt.edu.vn/uploads/images/news/${post.featured_image || post.image || "2f103b5b79ba1c68d2ab7520bd2525b4.png"}`}
                                                alt={post.title}
                                                style={{
                                                    maxWidth: '100%',
                                                    borderRadius: 8,
                                                    marginBottom: isMobile ? 8 : 16,
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                                    transition: 'transform 0.2s ease-in-out'
                                                }}
                                                onError={(e) => {
                                                    e.target.src = "https://utt.edu.vn/uploads/images/news/2f103b5b79ba1c68d2ab7520bd2525b4.png";
                                                }}
                                                onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                                                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                                            />
                                        </a>
                                        <a
                                            href={createArticleUrl(post)}
                                        >
                                            <h3
                                                style={{
                                                    fontSize: isMobile ? 15 : 20,
                                                    fontWeight: 500,
                                                    color: '#1a237e',
                                                    marginBottom: isMobile ? 6 : 12,
                                                    textAlign: 'left',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis', minHeight: isMobile ? 45 : 60,
                                                    cursor: 'pointer',
                                                    transition: 'color 0.2s ease-in-out'
                                                }}
                                                onMouseOver={(e) => e.target.style.color = '#f79421'}
                                                onMouseOut={(e) => e.target.style.color = '#1a237e'}
                                            >
                                                {post.title}
                                            </h3>
                                        </a>
                                        <p
                                            style={{
                                                fontSize: isMobile ? 12 : 16,
                                                color: '#333',
                                                textAlign: 'left',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                minHeight: isMobile ? 32 : 40
                                            }}                                            >
                                            {post.excerpt || post.description || post.content}
                                        </p>
                                    </div>
                                </SwiperSlide>
                            ))
                        ) : (
                            // No data fallback
                            <SwiperSlide>
                                <div style={{
                                    background: '#f5f5f5',
                                    borderRadius: 12,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                    padding: isMobile ? 8 : 16,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: isMobile ? 180 : 350,
                                    height: '100%',
                                }}>
                                    <p style={{
                                        fontSize: isMobile ? 14 : 16,
                                        color: '#666',
                                        textAlign: 'center',
                                    }}>
                                        Không có dữ liệu tuyển sinh
                                    </p>
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>

                </div>
            </section >
        </>
    );
};

export default AdmissionNews;